
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EllipseDecoration',

  props: {
    mimeTypeSlag: String
  }
})
